import { attachBetSlipMetadata, type BetSlipMetadata } from './betSlipService';

export type EmitMessage = <T>(_destination: string, _data: T) => boolean;

export interface BetSubmissionResult<T> {
  sent: boolean;
  payload: T & Partial<BetSlipMetadata>;
}

export interface BetsSubmissionResult<T> {
  sent: boolean;
  payloads: Array<T & Partial<BetSlipMetadata>>;
}

export const submitBet = async <T extends { clientBetId: string }>(
  emitMessage: EmitMessage,
  payload: T
): Promise<BetSubmissionResult<T>> => {
  const signedPayload = await attachBetSlipMetadata(payload);
  return {
    sent: emitMessage('/app/game/bet', { bet: signedPayload }),
    payload: signedPayload,
  };
};

export const submitBets = async <T extends { clientBetId: string }>(
  emitMessage: EmitMessage,
  payloads: T[]
): Promise<BetsSubmissionResult<T>> => {
  const signedPayloads = await Promise.all(payloads.map(attachBetSlipMetadata));
  return {
    sent: emitMessage('/app/game/bets', { bets: signedPayloads }),
    payloads: signedPayloads,
  };
};
